import type { ComponentProps } from 'react';
import React from 'react';
import { View } from 'react-native';
import {
  DisplayText,
  TitleText,
  TYPE_CONFIG,
  useResponsive,
} from '@sweetgreen/garnish';

type GreetingsProps = {
  readonly greeting: string;
  readonly heroHeadline: string;
} & ComponentProps<typeof View>;

export const Greetings = React.memo((props: GreetingsProps) => {
  const { greeting, heroHeadline, style, ...rest } = props;

  return (
    <View style={style} {...rest}>
      <GreetingText testID="homepage.welcome-text">{greeting}</GreetingText>

      <HeroHeadlineText>{heroHeadline}</HeroHeadlineText>
    </View>
  );
});

// ─── TEXT COMPONENTS ──────────────────────────────────────────────────────────────────

type GreetingTextProps = {
  readonly children: React.ReactText;
} & ComponentProps<typeof DisplayText>;

export const GreetingText = React.memo((props: GreetingTextProps) => {
  const { children, style, ...rest } = props;

  const { fluid } = useResponsive();
  const fluidStyles = {
    fontSize: fluid(TYPE_CONFIG.DISPLAY['32'].fontSize ?? 32, 56),
    lineHeight: fluid(TYPE_CONFIG.DISPLAY['32'].lineHeight ?? 36, 56),
    letterSpacing: fluid(0, 1),
  };

  const styles = [fluidStyles, style];

  return (
    <DisplayText style={styles} {...rest}>
      {children}
    </DisplayText>
  );
});

type HeroHeadlineProps = {
  readonly children: React.ReactText;
} & ComponentProps<typeof TitleText>;

export const HeroHeadlineText = React.memo((props: HeroHeadlineProps) => {
  const { children, style, ...rest } = props;

  const { fluid } = useResponsive();
  const fluidStyles = {
    fontSize: fluid(32, 56),
    lineHeight: fluid(32, 56),
    letterSpacing: fluid(-1.6, -3),
  };

  const styles = [fluidStyles, style];

  return (
    <TitleText style={styles} {...rest}>
      {children}
    </TitleText>
  );
});
